module.exports = __webpack_public_path__ + "img/img29.72d46ba4.png";